// @ts-nocheck
/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_gb2_assistant_errors_nopurchaseorderfound3 = /** @type {(inputs: { number: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Purchase order with number ${i?.number} not found.`)
};

const en_us2_assistant_errors_nopurchaseorderfound3 = /** @type {(inputs: { number: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Purchase order with number ${i?.number} not found.`)
};

const de_de2_assistant_errors_nopurchaseorderfound3 = /** @type {(inputs: { number: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bestellung mit Nummer ${i?.number} nicht gefunden.`)
};

const en_assistant_errors_nopurchaseorderfound3 = /** @type {(inputs: { number: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Purchase order with number ${i?.number} not found.`)
};

const de_assistant_errors_nopurchaseorderfound3 = /** @type {(inputs: { number: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bestellung mit Nummer ${i?.number} nicht gefunden.`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ number: NonNullable<unknown> }} inputs
* @param {{ locale?: "en-GB" | "en-US" | "de-DE" | "en" | "de" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
const assistant_errors_nopurchaseorderfound3 = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.assistant_errors_nopurchaseorderfound3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("assistant_errors_nopurchaseorderfound3", locale)
	if (locale === "en-GB") return en_gb2_assistant_errors_nopurchaseorderfound3(inputs)
	if (locale === "en-US") return en_us2_assistant_errors_nopurchaseorderfound3(inputs)
	if (locale === "de-DE") return de_de2_assistant_errors_nopurchaseorderfound3(inputs)
	if (locale === "en") return en_assistant_errors_nopurchaseorderfound3(inputs)
	return de_assistant_errors_nopurchaseorderfound3(inputs)
};
export { assistant_errors_nopurchaseorderfound3 as "assistant.errors.noPurchaseOrderFound" }